<template>
  <v-menu
    location="bottom center"
    :offset="[8, 0]"
  >
    <template v-slot:activator="{ props }">
      <v-btn
        v-bind="props"
        variant="text"
        icon
        data-cy="user-profile-menu"
      >
        <v-avatar size="32" color="grey-lighten-2">
          <img v-if="avatarUrl" :src="avatarUrl" alt="Profile" style="width: 100%; height: 100%; object-fit: cover;" />
          <span v-else-if="userInitials" class="text-subtitle-1">{{ userInitials }}</span>
          <v-icon v-else>mds:account-circle</v-icon>
        </v-avatar>
      </v-btn>
    </template>

    <v-list density="compact">
      <template v-if="isUserLoggedIn">
        <v-list-item :to="{ path: '/account/profile' }" prepend-icon="mds:person">
          <v-list-item-title>My profile</v-list-item-title>
        </v-list-item>

        <v-list-item :to="{ path: '/subscription/my-plan' }" prepend-icon="mdi-account-credit-card-outline"
                     v-if="subscriptionAccessType !== 'NO_ACCESS'">
          <v-list-item-title>Plan & Billing</v-list-item-title>
        </v-list-item>

        <v-list-item :to="{ path: '/settings' }" prepend-icon="mds:corporate-fare"
                     v-if="subscriptionAccessType !== 'NO_ACCESS'">
          <v-list-item-title>My organisations</v-list-item-title>
        </v-list-item>

        <v-list-item @click="logout" prepend-icon="mds:logout">
          <v-list-item-title>Log out</v-list-item-title>
        </v-list-item>
      </template>
      <template v-else>
        <v-list-item @click="logout" prepend-icon="mds:login">
          <v-list-item-title>Log in</v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { authHelpers } from '@/api/authHelpers'
import useBroadcastChannel from '@/composables/useBroadcastChannel'
import { useAvatarUrl } from '@/composables/useAvatarUrl'

const store = useStore()
const router = useRouter()
const { sendMessage } = useBroadcastChannel()

const isUserLoggedIn = computed(() => store.state.isUserLoggedIn)
const userInfo = computed(() => store.state.userInfo)
const currentUser = computed(() => store.state.user.user)
const subscriptionAccessType = computed(() => store.state.payments.subscriptionAccessType)

const userInitials = computed(() => {
  if (!currentUser.value) return ''
  const first = currentUser.value.firstname?.charAt(0)?.toUpperCase() || ''
  const last = currentUser.value.lastname?.charAt(0)?.toUpperCase() || ''
  return first + last
})

const { avatarUrl } = useAvatarUrl(computed(() => currentUser.value?.picture))

const logout = () => {
  sendMessage('LOGOUT', { loggedInUser: userInfo.value })
  authHelpers.logoutAndClearStore()
  router.push({ path: '/login' })
}
</script>
